module.exports = __webpack_public_path__ + "static/Vedalken_Izzet_Blastseeker-1cc867ec4cb8812f0eddac04119fed42.jpg";